(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    const elementSections = document.getElementById("js-element-sections");

    if (!elementSections) return;

    const pageContent = document.getElementById("main-page-content");

    if (!pageContent) return;

    const elements = Array.from(pageContent.querySelectorAll(".element"));

    if (elements.length === 0) return;

    const sectionsList = elementSections.querySelector("#page-sections");
    const removeLeadingNumbers =
      elementSections.getAttribute("data-remove-leading-numbers") === "1";
    const ignoredTitles = (elementSections.getAttribute("data-ignored-titles") || "")
      .split(",")
      .map((title) => title.trim().toLowerCase())
      .filter(Boolean);

    const stripLeadingNumbers = (title) =>
      title.replace(/^\d+(?:\.\d+)+\s*/, "");

    elements.forEach((element) => {
      const heading = element.querySelector("h2");

      if (!heading) return;

      if (heading.classList.contains("sections-exclude")) return;

      const originalTitle = heading.textContent.trim();
      const displayTitle = removeLeadingNumbers
        ? stripLeadingNumbers(originalTitle)
        : originalTitle;

      if (
        ignoredTitles.includes(originalTitle.toLowerCase()) ||
        ignoredTitles.includes(displayTitle.toLowerCase())
      ) {
        return;
      }

      let li = document.createElement("li");
      let link = document.createElement("a");

      link.href = `#${element.id}`;
      link.textContent = displayTitle;

      li.appendChild(link);

      sectionsList.appendChild(li);
    });
  });
})();
